import { company } from "@/lib/siteData";

export function buildWhatsAppUrl({ name, phone, city, service, message }) {
  const text = [
    "Olá, Desentupidora Ambiental! Preciso de atendimento.",
    `Nome: ${name || "Não informado"}`,
    `Telefone: ${phone || "Não informado"}`,
    `Cidade: ${city || "Não informada"}`,
    `Serviço: ${service || "Não informado"}`,
    `Mensagem: ${message || "Gostaria de receber orçamento."}`,
  ].join("\n");

  return `https://wa.me/${company.whatsapp}?text=${encodeURIComponent(text)}`;
}

export function directWhatsAppUrl(context = "Atendimento emergencial 24 horas") {
  return `https://wa.me/${company.whatsapp}?text=${encodeURIComponent(
    `Olá, Desentupidora Ambiental! Preciso de ${context}.`,
  )}`;
}